import React, { useState } from "react";

import { Layout, MetaTag } from "src/components";
import { OrderForm } from "../../components";
import { Card, Col, Row, Spin } from "antd";

const EditView = (props: any) => {
    const { orderData, onFinish, onFinishFailed } = props;

    return (
        <Layout
            titles={[
                { name: "Orders", link: "/order" },
                { name: "Edit", link: "" },
                { name: orderData?.name, link: "" },
            ]}
        >
            <MetaTag title="Add Order" />
            <Row justify="center" align="middle">
                <Col xs={12} lg={20} md={24}>
                    <Card
                        style={{ borderRadius: "8px", padding: "12px" }}
                        title={"Order Update"}
                        bordered={true}
                    >
                        {orderData && (
                            <OrderForm
                                order={orderData}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                            />
                        )}
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default EditView;
